import * as types from "../actionTypes/GuestActionTypes";
import * as apis from "../api/api";
import axios from "../../Uri";
import * as api from "../api/api";
export const getTotalAmountPaidByGuest = (guestId) => (dispatch) => {
  axios
    .get(`payment/getTotalPaid/${guestId}`)
    .then((response) => {
      dispatch({ type: types.GUEST_TOTAL_PAID, payload: response.data });
      dispatch({ type: types.SUCCESS_RESPONSE, payload: true });
    })
    .catch((error) => {
      console.log(error);
      dispatch({ type: types.FAILURE_RESPONSE, payload: false });
    });
};

export const getRecentTransaction = (buildingId) => (dispatch) => {
  axios
    .get(`/payment/recentTransactions/${buildingId}`)
    .then((response) => {
      dispatch({ type: types.RECENT_TRANSACTION, payload: response.data });
      dispatch({ type: types.SUCCESS_RESPONSE, payload: true });
    })
    .catch((error) => {
      console.log(error);
      dispatch({ type: types.FAILURE_RESPONSE, payload: false });
    });
};
export const getArchivedGuests=(pageNumber)=>(dispatch)=>{
  apis.getArchivedGuests(pageNumber).then((res)=>{
    const apiRes = res?.data;
    // const mergeData = [...data, ...apiRes.content];
    console.log(apiRes.content);
    dispatch({type:types.GET_ARCHIVED_GUESTS,payload:apiRes.content})
  }).catch((error)=>{
    console.log(error);
    dispatch({ type: types.FAILURE_RESPONSE, payload: false });
  });
  }


export const getCountOfFiltersInRat=(buildingId,occupancyType)=>(dispatch)=>{
  api.getCountOfFiltersInRat(buildingId,occupancyType).then((res)=>{
    console.log(res)
    dispatch({type: types.GET_FILTERED_BEDS_COUNT,payload:res.data.data})}).catch((error)=>{
      console.log(error);
      dispatch({ type: types.FAILURE_RESPONSE, payload: false });
  });
}
export const makeOccupancyTypeActive=(id,occupancyType)=>(dispatch)=>{
  dispatch({type: types.GET_SELECTED_OCCUPANCY_TYPE,payload:occupancyType})
}



export const monthlySumOfBuildindg=(id)=>(dispatch)=>{
axios.get(`/payment/getMonthlyCountByBuildingId/${id}`).then((res)=>{
  console.log(res)
  dispatch({type:types.MONTHLY_INCOME_BY_BUILDING,payload:res.data})
}).catch((err)=>{
  console.log(err)
})
}

export const todaysCheckOutGuest=(buildingId) => (dispatch) => {
  axios.get(`guest/findTodayOut/${buildingId}`).then((res)=> {
    console.log(res)
    dispatch({type:types.TODAYS_CHECKHOUT,payload:res.data})
  }).catch((err)=>{
    console.log(err)
  })
}